export default __webpack_public_path__ + "static/media/NunitoSans-Bold.8268666c.ttf";